   <!--Header Frontend Panel -->
   <app-header></app-header>
<router-outlet></router-outlet>

   <!-- Footer Frontend Panel -->
   <app-footer *ngIf="isFooter"></app-footer>